// SupplementReminderBanner — shown in Calories Log when the reminder
// time has passed and any of Yusuf's daily-5 supplements aren't logged.
// Each chip is a one-tap log (re-uses the same food bases as the Quick
// Add tiles). "Dismiss for today" hides the banner until tomorrow.

import React from 'react';

export default function SupplementReminderBanner({ missing, time, onLog, onDismiss, colors }) {
  if (!missing || !missing.length) return null;
  const { text, muted, border, s1, darkMode } = colors;
  return (
    <div style={{
      margin: "0 16px 10px", padding: "12px 14px",
      borderRadius: 14, background: s1,
      border: `0.5px solid ${border}`,
      display: "flex", flexDirection: "column", gap: 10,
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
          <span style={{ fontSize: 13, color: text, fontWeight: 700, letterSpacing: "-0.01em" }}>🌙 Supplement check</span>
          <span style={{ fontSize: 11, color: muted, fontFamily: "monospace" }}>{missing.length} pending · since {time}</span>
        </div>
        <button onClick={onDismiss} aria-label="Dismiss until tomorrow"
          style={{ padding: "4px 10px", borderRadius: 8, border: `1px solid ${border}`, background: "transparent", color: muted, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
          Dismiss
        </button>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {missing.map(d => (
          <button key={d.id} onClick={() => onLog(d)}
            aria-label={`Quick-log ${d.label}`}
            style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              padding: "8px 12px", borderRadius: 999,
              border: `1px solid ${d.color}66`,
              background: darkMode ? `${d.color}1f` : `${d.color}14`,
              color: d.color, fontSize: 12, fontWeight: 700,
              cursor: "pointer", fontFamily: "inherit",
              touchAction: "manipulation", WebkitTapHighlightColor: "transparent",
            }}>
            <span style={{ fontSize: 13 }}>{d.emoji}</span>
            <span>{d.label}</span>
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden="true" style={{ marginLeft: 2 }}>
              <path d="M6 2v8M2 6h8" stroke={d.color} strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
}
